var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGwangju(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x80\xE1\x85\xAA\xE1\x86\xBC\xE1\x84\x8C\xE1\x85\xAE 1",
    clipPath: "url(#clip0_1736_10025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.9562 0.012652C5.33599 0.311096 0.211098 5.91999 0.512654 12.5415C0.81421 19.1631 6.42177 24.2853 13.0429 23.9875C19.664 23.6898 24.788 18.0764 24.4873 11.4567C24.1867 4.83687 18.5787 -0.288904 11.9562 0.012652Z",
    fill: "#193282"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.5 6H6.5V18H18.5V6Z",
    fill: "#0090D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.5 6L9.49911 9.00089L12.5 6H6.5Z",
    fill: "#0090D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.5 6V11.9993L9.49911 9.00089L6.5 6Z",
    fill: "#0099D7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.5 12.0009L9.50089 9L6.5 12.0009H12.5Z",
    fill: "#0090D0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.5001 11.9993V6L9.50098 8.99844L12.5001 11.9993Z",
    fill: "#0081C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.5 6V11.9993L15.4984 9.00089L12.5 6Z",
    fill: "#0070BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.5 12.0009L15.5009 9L12.5 12.0009H18.5Z",
    fill: "#004B97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M6.5 12L9.49911 15.0016L12.5 12H6.5Z",
    fill: "#0081C8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.5 12V18.0002L9.49911 15.0016L6.5 12Z",
    fill: "#0070BA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.5 18.0011L9.50089 15L6.5 18.0011H12.5Z",
    fill: "#0066B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.5001 18.0002V12L9.50098 14.9991L12.5001 18.0002Z",
    fill: "#00519B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M12.5 12L15.4984 15.0016L18.5 12H12.5Z",
    fill: "#1A3180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M12.5 12V18.0002L15.4984 15.0016L12.5 12Z",
    fill: "#004B97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M18.5 18.0011L15.5009 15L12.5 18.0011H18.5Z",
    fill: "#1A3180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M18.5001 18.0002V12L15.501 14.9991L18.5001 18.0002Z",
    fill: "#1A3180"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M12.5 6L15.4984 9.00089L18.5 6H12.5Z",
    fill: "#0066B2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M18.5001 11.9993V6L15.501 8.99844L18.5001 11.9993Z",
    fill: "#00519B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M18.5001 13.5014L14.6581 9.8418L8.82812 15.6871L10.955 17.8136L14.6581 14.1667L18.5001 17.9874V13.5014Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_10025"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGwangju);
export default __webpack_public_path__ + "static/media/gwangju.1ed51de0d390ef74006846cc02fb15a6.svg";
export { ForwardRef as ReactComponent };